/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Link_Cancellation_TerminationInputs */

const tr_legal_footer_link_cancellation_termination = /** @type {(inputs: Legal_Footer_Link_Cancellation_TerminationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal ve Fesih`)
};

const en_legal_footer_link_cancellation_termination = /** @type {(inputs: Legal_Footer_Link_Cancellation_TerminationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation and Termination`)
};

const de_legal_footer_link_cancellation_termination = /** @type {(inputs: Legal_Footer_Link_Cancellation_TerminationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierung und Kündigung`)
};

const ru_legal_footer_link_cancellation_termination = /** @type {(inputs: Legal_Footer_Link_Cancellation_TerminationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена и расторжение`)
};

/**
* | output |
* | --- |
* | "Cancellation and Termination" |
*
* @param {Legal_Footer_Link_Cancellation_TerminationInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_link_cancellation_termination = /** @type {((inputs?: Legal_Footer_Link_Cancellation_TerminationInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Link_Cancellation_TerminationInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_link_cancellation_termination(inputs)
	if (locale === "de") return de_legal_footer_link_cancellation_termination(inputs)
	if (locale === "ru") return ru_legal_footer_link_cancellation_termination(inputs)
	return tr_legal_footer_link_cancellation_termination(inputs)
});